
const baseUrl = process.env.NODE_ENV === "production" ? "http://3.110.236.222:8000" : 'http://localhost:8000';

export {
    baseUrl,
}
